<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal" [from]="'residential_address_change'"></app-profile-confirm-modal>

<mapfre-alert *ngIf="showAlert" [closeButton] = "true" [notTop]="false"></mapfre-alert>

<ng-container *ngIf="addressType === 'mailing'">

<form 
  class="mailing"
  name="changeAddressForm"  
  [formGroup]="changeAddressForm" 
  (ngSubmit)="changeAddressForm.valid && changeAddress()">
  
  <div class=" residential_add">
  <div class="address-container" [ngClass]="{'po-box-section':isPOBoxAddSelected,'mailing-box-section':isMailingAddSelected}">
       <!-- <div class="notice-content margin-bottom mb24" *ngIf="showNotification && isAcmic">
      <div class="imp-notice">
        <div class="icon-block">
          <img src="./assets/img/images/icon-info-blue.svg" alt="info icon" />
        </div>
        <div class="imp-notice-content">
          <div class="imp-notie-header">
            <div class="imp-title">Important notice</div>
            <img src="./assets/img/images/icon-close-18.svg" alt="" (click)="closeNotification()">
          </div>
          <div class="imp-para">
            <div>
                Changing your mailing address will apply to all active policies.
              </div>
          </div>
        </div>
      </div>
    </div> -->
      <div class="toggle-notice-container">
          <div class="d-flex capsule_toggles">
            <mapfre-button [ngClass]="{'active': isMailingAddSelected, 'add-toggle-btn': true}"
              additionalClasses="basic large-btn mail-address-border" [inputType]="'button'"
              (click)="selectMailingAddressType('mailing-address')">
              {{'MAILING_ADDRESS' | translate}}
            </mapfre-button>
            <mapfre-button [ngClass]="{'active': isPOBoxAddSelected, 'add-toggle-btn': true}"
              additionalClasses="basic large-btn po-box-border" [inputType]="'button'"
              (click)="selectMailingAddressType('poBox-address')">
              {{'PO_BOX_ADDRESS' | translate}}
            </mapfre-button>
          </div>
          <div class="notice-content" *ngIf="showNotification && (isGWPolicy || isAcmic)">
            <div class="imp-notice">
              <div class="icon-block">
                <img src="./assets/img/images/icon-info-blue.svg" alt="info icon" />
              </div>
              <div class="imp-notice-content">
                <div class="imp-notie-header">
                  <div class="imp-title">Important notice</div>
                  <img src="./assets/img/images/icon-close-18.svg" alt="" (click)="closeNotification()">
                </div>
                <div class="imp-para">
                  <ng-container>
                    <div>
                      <ng-container *ngIf="hasAtleastOneLegacyPolicy; else gwPolicy">
                        Changing your mailing address will apply to all Mapfre Massachusetts personal active policies.
                      </ng-container>
                      <ng-template #gwPolicy>
                        Changing your mailing address will apply to all active policies.
                      </ng-template>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="address-section" >
        <div *ngFor="let input of inputs; index as index" class="input"
          [ngClass]="{'first-input change-address-width': input?.key === 'changeAddress',
            'second-input MA_AppSuite': input?.key === 'changeAddressAPT' && isAcmic,
            'MAZipCode': input?.key === 'changeAddress_zipCode' || input?.key === 'changeAddress_PO_zipCode',
            'MACityState': input?.key === 'changeAddress_city_state' || input?.key === 'changeAddress_PO_city_state',
            'MACitySelect': input?.key === 'changeAddress_multipleCities' || input?.key === 'changeAddress_PO_multipleCities',
            'MAState': input?.key === 'changeAddress_state' || input?.key === 'changeAddress_PO_state',
            'MASelectedState': isMailingAddSelected && (input?.key === 'changeAddress_state' || input?.key === 'changeAddress_PO_state'),
            'hide' : (input.key === 'changeAddress_city_state' && hideCityStateField)
            || (input.key === 'changeAddress_PO_city_state' && hidePoBoxCityStateField)
            || (input.key === 'changeAddress_zipCode' && isMailingAddSelected && hideZipcodeField),
            'hides' : ((input.key === 'changeAddress_multipleCities' || input.key === 'changeAddress_state') && (isPOBoxAddSelected || hideMultipleCityStateField))
              || (input.key === 'changeAddress_PO_multipleCities' || input.key === 'changeAddress_PO_state') && (isMailingAddSelected || hidePOMultipleCityStateField) }">
          <ng-container *ngIf="input.inputType !== 'select'">
            <mapfre-validation [input]="input" (addressinputValidationCheck)="isFormValid($event)"
              [form]="changeAddressForm" [ngClass]="{'hide' : ((input.key === 'changeAddress' || input?.key === 'changeAddress_zipCode'
                || input?.key === 'changeAddress_city_state') && isPOBoxAddSelected)
                || ((input.key ==='changeAddress_poBox' || input?.key === 'changeAddress_PO_zipCode'
                || input?.key === 'changeAddress_PO_city_state') && isMailingAddSelected),
              'hides': input.key === 'changeAddressAPT' && isPOBoxAddSelected }"></mapfre-validation>
            <label class="custom_label" *ngIf="index === 0"
              [ngClass]="{ 'hide' : input.key === 'changeAddress' && isPOBoxAddSelected }">
              {{'NUMBER_AND_STREET' | translate}}
            </label>
            <label class="custom_label" *ngIf="input?.key === 'changeAddressAPT'"
              [ngClass]="{'hide' : isPOBoxAddSelected}">{{'OPTIONAL' | translate}}
            </label>
          </ng-container>
          <ng-container *ngIf="input.inputType === 'select'">
            <label class="custom_city_label">{{'City' | translate}}</label>
            <select [id]="input.key" [formControlName]="input.key" class="custom-select custom-select-font mb8"
              (change)="onCityChange($event)">
              <ng-container *ngIf="isMailingAddSelected">
                <option *ngFor="let opt of multipleCityOptionsForMailing; index as index;" [value]="opt">
                  {{opt}}
                </option>
              </ng-container>
              <ng-container *ngIf="isPOBoxAddSelected">
                <option *ngFor="let opt of multipleCityOptionsForPOBox; index as index;" [value]="opt">
                  {{opt}}
                </option>
              </ng-container>
            </select>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="address-btn-container" [ngClass]="{'po-box-section':isPOBoxAddSelected}">
    <div class="">
      <!-- <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn change-address-btn'"
        [disabledValue]="changeAddressForm.valid && !loader && (isMailingAddSelected ? enableSubmitBtn: true) && (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid)"
        [inputType]="'submit'"
        [translateValue]="'UPDATE_ADDRESS' | translate"
      ></mapfre-button> -->
      <mapfre-modal [modalOptions]="confirmationModal" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()"
            [disabledValue]="changeAddressForm.valid && !loader && (isMailingAddSelected ? enableSubmitBtn: true) && (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid)"
            (click)="triggerObjectCretion()">
        <div class="modal-body">
          <div class="modal-close-btn " >
            <img src="./assets/img/images/icon-close-24.svg" alt="close icon" (click)="hideModalAction()">
          </div>
          <div class="modal-outter-container">
            <ng-container>
                <div class="header-icon">
                    <img alt="warningicon" src="./assets/img/images/icon-warning-64.svg">
                </div>
            </ng-container>
            <div class="modal-inner-content">
              <div class="modal-title">
                Confirm address update
              </div>
              <div class="sub-title">
                Are you sure you want to update?
              </div>
              <div class="detail-section">
                <div class="address-detail-section current-address">
                  <div class="label">
                    Current address:
                  </div>
                  <div class="current-address-value">
                    <p>{{currentStreetAPT}} {{currentStreetName}} </p>
                      <p>{{currentAddressObject?.city}}, {{currentAddressObject?.state}} {{currentAddressObject?.zipCode?.code}}</p>
                  </div>
                </div>
                <div class="address-detail-section">
                  <div class="label">
                    New address:
                  </div>
                  <div class="current-address-value">
                      <p>{{changeAddressForm?.controls?.changeAddressAPT?.value}} {{isMailingAddSelected ? newStreetName : addressObject?.address?.streetName}} </p>
                      <p> {{addressObject?.address?.city}}, {{addressObject?.address?.state}} {{addressObject?.address?.zipCode?.code}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="second-confirmation">
              <div class="confirmation-text">
                After you confirm, the previous address will no longer be valid.
              </div>
            </div>
            <!-- [ngClass]="{ custom_loader: loader }" -->
            <div class="modal-btn-container">
              <div class="confirm-btn">
                <mapfre-button [ngClass]="{ 'custom_loader custom_loader_address': loader }"
                additionalClasses="basic primary large-btn"  (click)="changeAddress()">
                  Confirm New Address
                </mapfre-button>
              </div>
              <div class="cancel-btn">
                <mapfre-button additionalClasses="ghost secondary large-btn " (click)="hideModalAction()">
                  {{ "CANCEL" | translate }}
                </mapfre-button>
              </div>
            </div>
          </div>
        </div>
      </mapfre-modal>
    </div>
    <div class="cancel-btn">
      <mapfre-button
        [additionalClasses]="'ghost secondary large-btn'"
        [backIcon]="'./assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        (click)="onCheckDirty()">  
       {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>
</form>


</ng-container>
<ng-container *ngIf="addressType === 'residential'">
<form
  class="residential"
  name="changeAddressForm" 
  [formGroup]="changeAddressForm" 
   (ngSubmit)="changeAddressForm.valid && changeAddress()">
  
  <div class="margin-bottom mb8 residential_add editResidential">
      <div *ngFor="let input of inputs; index as index" class="input"
        [ngClass]="{'first-input change-address-width': input?.key === 'changeAddress',
         'second-input': input?.key === 'changeAddressAPT' && isAcmic,
         'hide' : (input?.key === 'changeAddress_poBox')
          || (input?.key === 'changeAddress_zipCode')
          || (input?.key === 'changeAddress_city_state')
          || (input?.key === 'changeAddress_PO_zipCode')
          || (input?.key === 'changeAddress_PO_city_state')
          || (input?.key === 'changeAddress_multipleCities')
          || (input?.key === 'changeAddress_PO_multipleCities')
          || (input?.key === 'changeAddress_state')
          || (input?.key === 'changeAddress_PO_state') }">
      <mapfre-validation [input]="input" [form]="changeAddressForm" [policyStateCode]="policyStateCode"
        (addressinputValidationCheck)="isFormValid($event)"></mapfre-validation>
      <label class="custom_label" *ngIf="input?.key === 'changeAddress' && isAcmic">{{'NUMBER_AND_STREET' | translate}}</label>
      <label class="custom_label" *ngIf="input?.key === 'changeAddressAPT' && !isAcmic"
            [ngClass]="{'hide' : isPOBoxAddSelected}">{{'OPTIONAL' | translate}}
          </label>
    </div>
  </div>
  <div class="row margin-bottom mb8 radio-container h-auto">
    <div class="col">
      <ng-container *ngIf="isAcmic; else maNotice">
        <div *ngIf="state === 'MA'" class="margin-bottom mb8 font-color font-style">{{ 'RESIDENTIAL_ADDRESS_TEXT' | translate }}
          <a class="underline"
          [routerLink]="['/contact']"><span class="blue-text">{{'CONTACT_AGENT' | translate}}</span></a>
      </div>
      <div *ngIf="state === 'WA'" class="margin-bottom mb8 font-color font-style"><center>{{ 'RESIDENTIAL_ADDRESS_TEXT_WA' | translate  }}</center>{{ 'RESIDENTIAL_ADDRESS_TEXT_WA2' | translate  }}
        <a 
        [routerLink]="['/contact']"><span class="blue-text"><u>{{ 'CONTACT_US_2' | translate }}</u></span></a>
        {{ 'RESIDENTIAL_ADDRESS_TEXT_2' | translate  }}
      </div>
      <div *ngIf="state === 'ID'" class="margin-bottom mb8 font-color font-style"><center>{{ 'RESIDENTIAL_ADDRESS_TEXT_ID' | translate  }}</center>{{ 'RESIDENTIAL_ADDRESS_TEXT_ID2' | translate  }}
        <a 
        [routerLink]="['/contact']"><span class="blue-text"><u>{{ 'CONTACT_US_2' | translate  }}</u></span></a>
        {{ 'RESIDENTIAL_ADDRESS_TEXT_2' | translate  }}
      </div>
      </ng-container>
      <ng-template #maNotice>
        <div *ngIf="state === 'MA'">
          <div class="row notice-content">
            <app-imp-notice
            [theme]="'blue'" 
            [impText]="'RESIDENTIAL_ADDRESS_TEXT' | translate"
            [linkUrl]="'/contact'"
            [linkText]="'CONTACT_AGENT' | translate"
            >            
            </app-imp-notice>
          </div>          
      </div>
      <div *ngIf="state === 'WA'">
        <div class="row notice-content">
          <app-imp-notice
          [theme]="'blue'" 
          [impText]="'RESIDENTIAL_ADDRESS_TEXT_WA_NEW' | translate"
          [linkUrl]="'/contact'"
          [linkText]="'CONTACT_US_2' | translate"
          >            
          </app-imp-notice>
        </div>        
      </div>
      <div *ngIf="state === 'ID'" class="margin-bottom mb8 font-color font-style">
        <center>{{ 'RESIDENTIAL_ADDRESS_TEXT_ID' | translate  }}</center>{{ 'RESIDENTIAL_ADDRESS_TEXT_ID2' | translate  }}
        <a 
        [routerLink]="['/contact']"><span class="blue-text"><u>{{ 'CONTACT_US_2' | translate  }}</u></span></a>
        {{ 'RESIDENTIAL_ADDRESS_TEXT_2' | translate  }}
      </div>
      </ng-template>
      <div class="row margin-top mt32 margin-bottom mb24 checkbox" >
        <div class="col">
          <input
            class="single-checkbox"
            type="checkbox"
            id="legal-checkbox"
            [formControlName]="'isMailingAddress'"
            >
          <label class="form-check-label font-color disclaimer disclaimer" for="legal-checkbox">{{ 'UPDATE_MAILING_ADD' | translate }}</label>
        </div>
      </div>
      <div class="row margin-top mt32 checkbox" [ngClass]="{'margin-bottom mb24': isAcmic}" *ngIf="policyStateCode!== 'CA'"> 
        <label class="form-check-label font-color disclaimer disclaimer label" for="legal-checkbox">Will all your vehicles be garaged at this new location?</label>
      </div> 
      <ng-container *ngIf="isAcmic; else maLocationFlag">
        <div class="row margin-top radio-button mt12 margin-bottom mb24 checkbox">
          <div class="margin-left ml12 d-inline">
            <input type="radio" class="radio-button" id="residential-car-yes" name="isLocationSame" [formControlName]="'isLocationSame'" value="true">
            <label class="no-margin-bottom align-top" for="residential-car-yes">{{'YES' | translate}}</label>
          </div> 
          <div class="margin-left ml32 d-inline">
            <input type="radio" class="" id="residential-car-no" name="isLocationSame" [formControlName]="'isLocationSame'" value="false">
            <label class="no-margin-bottom align-top" for="residential-car-no">{{'NO' | translate}}</label>
          </div>   
        </div>
      </ng-container>
      <ng-template #maLocationFlag>
        <div class="d-flex capsule_toggles margin-bottom mb8" *ngIf="policyStateCode!== 'CA'">
          <mapfre-button
            [ngClass]="{'active': isLocationSame, 'add-toggle-btn': true}"
            additionalClasses="basic large-btn mail-address-border"
            [inputType]="'button'"
            (click)="selectResidentialFlag('Yes')">
            {{'YES' | translate}}
          </mapfre-button>
          <mapfre-button
            [ngClass]="{'active': !isLocationSame, 'add-toggle-btn': true}"
            additionalClasses="basic large-btn po-box-border"
            [inputType]="'button'"
            (click)="selectResidentialFlag('No')">
            {{'NO' | translate}}
          </mapfre-button>
         </div>
      </ng-template>      
    </div> 
  </div>

  <div class="row text-center">
    <div class="col">
      <mapfre-button
        [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn'"
        [disabledValue]="changeAddressForm.valid && enableSubmitBtn && !loader" 
        [inputType]="'submit'"
        [translateValue]="'UPDATE_ADDRESS' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>

<div class="row text-center margin-top mt24">
    <div class="col">
      <mapfre-button
        [additionalClasses]="'link-button red-link small button-border-red'"
        [backIcon]="'./assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [showIconsCustom]="true"
        (click)="onCheckDirty()">  
       {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>
  <div class="font-color font-style" *ngIf="state === 'WA' || state === 'ID'"> 
    {{ 'GARAGED_YES' | translate }}
    {{ 'GARAGED_YES2' | translate}}<a 
    [routerLink]="['/contact']"><span class="blue-text"><u>{{ 'CONTACT_US_2' | translate }}</u></span></a>.
  </div>
</ng-container>
